import { namespace, TypeUserDataReducer } from "./types";

const getInitial = (
  state: Record<namespace, TypeUserDataReducer>
): TypeUserDataReducer => state.updateUserData;

export const getUserUpdateData = (
  state: Record<namespace, TypeUserDataReducer>
) => getInitial(state);
